var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class Poster2025 extends Component {
    constructor() {
        super('Poster', false);
        this.slides = $('.poster-2025 .slide');
        this.currentSlide = 1;
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            if (this.slides.length > 0) {
                this.resize();
                this.position = this.startX;
                this.setMaskPosition(this.slides, 'left 0 top ' + this.startX + 'px');
                this.setMaskPosition(this.slides.eq(0), 'left 0 top ' + (this.startX * -1) + 'px');
                setTimeout(() => {
                    this.transition();
                }, 1000);
                $(window).on('resize', () => {
                    this.resize();
                });
            }
            this.success();
        });
    }
    resize() {
        this.ratio = 2560 / $(window).width();
        this.step = 180 / this.ratio;
        this.startX = $('.poster-2025').height();
    }
    transition() {
        let interval = setInterval(() => {
            this.position -= this.step;
            this.setMaskPosition(this.slides.eq(this.currentSlide), 'left 0 top ' + this.position + 'px');
            if (this.position < -this.startX) {
                clearInterval(interval);
                let delay = [1, 3].includes(this.currentSlide) ? 0 : 1000;
                if (this.currentSlide >= this.slides.length - 1) {
                    this.currentSlide = 0;
                    this.setMaskPosition(this.slides, 'left 0 top ' + this.startX + 'px');
                    this.setMaskPosition(this.slides.eq(0), 'left 0 top ' + (this.startX * -1) + 'px');
                }
                setTimeout(() => {
                    this.position = this.startX;
                    this.currentSlide++;
                    this.transition();
                }, delay);
            }
        }, $(window).width() / $(window).height() > 1 ? 50 : 25);
    }
    setMaskPosition(element, value) {
        element.css({
            '-webkit-mask-position': value,
            'mask-position': value
        });
    }
}
